import React, { useMemo } from 'react';

import { LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import SelectLockboxClaims from './SelectLockboxClaims';
import ViewSelectedClaims from './ViewSelectedClaims';

const LockboxClaims = () => {
  const { editableLockbox, isEditMode, isDividingMode } = useLockboxDetailsStore();

  const isAvailable = useMemo(() => editableLockbox?.lockboxType === LockboxType.CLAIM_REPAYMENT, [editableLockbox]);

  if (!isAvailable || isDividingMode || editableLockbox?.isMultipleRecordsWarning) {
    return null;
  }

  if (isEditMode) {
    return <SelectLockboxClaims />;
  }

  return <ViewSelectedClaims />;
};

export default LockboxClaims;
